<div data-testid="order-short-page" class="order-short-container flex-table-page">
  <!-- Main Content -->
  <div class="main-content p-4 flex flex-col flex-1 min-h-0">
    <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
      {{ 'order.short.title' | translate }}
    </h2>
    <!-- Search Form -->
    <app-search-form
      data-testid="order-short-search-form"
      [orderSources]="channels"
      [salesChannels]="stores"
      [buyerNotesOptions]="orderSources"
      [giftOptions]="giftOptions"
      (formSearch)="onSearch($event)"
      (formReset)="onReset()"
    ></app-search-form>
    
    <!-- Data Table -->
    <div class="flex-table-section">
      <app-data-table
        data-testid="order-short-table"
        [dataSource]="orders"
        [columns]="columns"
        [rows]="rows"
        [first]="first"
        [totalRecords]="totalRecords"
        [loading]="loading"
        scrollHeight="flex"
        (pageChange)="onPageChange($event)">
      </app-data-table>
    </div>
  </div>
</div> 
